import emailRemindersStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    addToNewReminderIdMap,
    removeFromNewReminderIdMap,
    resetNewReminderIdMap,
} from '../actions/newReminderIdMapActions';

mutator(addToNewReminderIdMap, actionMessage => {
    const { id } = actionMessage;
    emailRemindersStore.newReminderIdMap[id] = true;
});

mutator(removeFromNewReminderIdMap, actionMessage => {
    const { id } = actionMessage;
    delete emailRemindersStore.newReminderIdMap[id];
});

mutator(resetNewReminderIdMap, () => {
    emailRemindersStore.newReminderIdMap = {};
});
